import { useEffect } from 'react';

const useUpdateTitle = (title: string) => {
  useEffect(() => {
    document.title = `${title} | AAA Insurance`;
  }, [title]);
};

export default useUpdateTitle;
